import { take, call, put } from 'redux-saga/effects';
import { taskForms as actionTypes } from '$constants/action-types';
import { fetchAllSuccess } from '$actions/task-forms';
import axios from 'axios';

const fetchAll = (projectId) => axios.get(`/projects/${projectId}/task_forms`);
const fetch = (projectId, id) => axios.get(`/projects/${projectId}/task_forms/${id}`);

function* watchFetchAll() {
  while(true) {
    const action = yield take(actionTypes.FETCH_ALL);
    const { data } = yield call(fetchAll, action.projectId);
    const taskForms = [];

    for(let item of data.data) {
      const itemResponse = yield call(fetch, action.projectId, item.id);
      itemResponse.data.data.project_id = action.projectId;
      taskForms.push(itemResponse.data.data);
    }

    yield put(fetchAllSuccess(taskForms));
  }
}

export const watchers = [
  watchFetchAll
];



// WEBPACK FOOTER //
// ./src/sagas/task-forms.js